<template>
  <b-modal v-model="show" size="xl" centered header-bg-variant="primary" hide-footer title="Reward Setting" @show="setData()" @hide="cancelModal()">
    <b-row v-if="!setOccurrence">
      <b-col sm="6">
        <p-radio v-model="form.filter" label="Reward Type Filter" name="filter" :handler="$v" :formData="form" :options="actionList" />
      </b-col>
      <b-col sm="3">
        <template v-if="checkAccessPrivilege('ScratchCard.Settings.Rewards.Update')">
          <label class="mr-sm-2" for="device">Action</label><br/>
          <b-btn variant="primary" @click="moveAll(0)"><i class="fa fa-angle-double-left"></i></b-btn>
          <b-btn variant="primary" @click="moveAll(1)"><i class="fa fa-angle-double-right"></i></b-btn>
        </template>
      </b-col>
      <b-col sm="3">
        <div class="float-right">
          <label class="mr-sm-2" for="device"><span style="opacity: 0">Action</span></label><br/>
          <b-btn variant="success" @click="next()" v-if="checkAccessPrivilege('ScratchCard.Settings.Rewards.Update')">Set Occurrence</b-btn>
          <b-btn variant="outline-danger" @click="cancelModal()">Cancel</b-btn>
        </div>
      </b-col>
      <b-col sm="12">
        <b-row>
          <b-col sm="6">
            <div class="list-wrapper">
              <b-row>
                <b-col sm="12"><strong><em>Pick Cards to add</em></strong></b-col>
                <b-col sm="3" v-for="(val, key) in rewardListFilter" :key="`rl-${key}`" @click="selectReward(val, 1)">
                  <div class="reward-wrapper">
                    <div class="reward-img">
                      <img :src="val.ImageUrl" :alt="val.Name" width="100%">
                    </div>
                    <div class="reward-info">
                      <strong>{{ val.Name}}</strong><br/><em>{{ val.Amount }} {{ (val.Type === 1) ? 'Credit' : (val.Type === 2) ? 'Points' : '' }}</em>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="6">
            <div class="list-wrapper">
              <b-row>
                <b-col sm="12"><strong><em>Pick Cards to remove</em></strong></b-col>
                <b-col sm="3" v-for="(val, key) in rewardSettingFilter" :key="`rl-${key}`" @click="selectReward(val, 0)">
                  <div class="reward-wrapper">
                    <div class="reward-img">
                      <img :src="val.ImageUrl" :alt="val.Name" width="100%">
                    </div>
                    <div class="reward-info">
                      <strong>{{ val.Name}}</strong><br/><em>{{ val.Amount }} {{ (val.Type === 1) ? 'Credit' : (val.Type === 2) ? 'Points' : '' }}</em>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col sm="12">
        <h3 class="float-left">Sample Size: <em>{{ sampleSize }}</em></h3>
        <div class="float-right">
          <label class="mr-sm-2" for="device"><span style="opacity: 0">Action</span></label><br/>
          <b-btn variant="success" @click="save()">Save</b-btn>
          <b-btn variant="danger" @click="goBack()">Go Back</b-btn>
          <b-btn variant="outline-danger" @click="cancelModal()">Cancel</b-btn>
        </div>
      </b-col>
      <b-col sm="12">
        <div class="reward-setting-data-list-wrapper">
          <b-row>
            <b-col sm="2"  v-for="(val, key) in rewardSettingDataList" :key="`s-${key}`">
              <div class="reward-wrapper">
                <div class="reward-info">
                  <strong>{{ val.Name}}</strong><br/><em>{{ val.Amount }} {{ (val.Type === 1) ? 'Credit' : (val.Type === 2) ? 'Points' : '' }}</em>
                </div>
                <div class="reward-img">
                  <img :src="val.ImageUrl" :alt="val.Name" width="100%">
                </div>
                <div class="reward-occurrence">
                  <p-input v-model="form.rewards[key].occurrence" name="rewards" :handler="$v" label="Occurrence Value" :formData="form" type="text">
                    <em>Percentage: {{ format(getPercent(form.rewards[key].occurrence), "0.00%") }}</em>
                  </p-input>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { PRadio, PInput } from '../../../components'
import numeral from 'numeral'
const _ = require('underscore')

export default {
  name: 'scratchcard-reward-setting',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: Number,
      default: 0
    },
    rewardList: {
      type: Array,
      default: []
    },
    rewardSettingData: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      fields: [
        {key: 'Name', label: 'Name'},
        {key: 'ImageUrl', label: 'Image Url'},
        {key: 'Price', label: 'Price'},
        {key: 'Occurrence', label: 'Occurrence'}
      ],
      actionList: [
        { value: 0, text: 'All' },
        { value: 1, text: 'Credits' },
        { value: 2, text: 'Points' }
      ],
      form: {
        filter: 0,
        rewards: []
      },
      rewardListData: [],
      rewardSettingDataList: [],
      setOccurrence: false
    }
  },
  components: {
    PRadio,
    PInput
  },
  validations: {
    form: {
      filter: {},
      rewards: []
    }
  },
  computed: {
    show: {
      get: function () {
        return this.showModal
      },
      set: function () {
        return this.showModal
      }
    },
    rewardListFilter: function () {
      let filter = this.form.filter
      return this.checkSelected.filter(function (x) {
        return [1, 2].includes(filter) ? x.Type === filter : x
      })
    },
    checkSelected: function () {
      let rewardSettingData = this.rewardSettingFilter
      return this.rewardListData.filter(function (x) {
        return !(_.pluck(rewardSettingData, 'Id').includes(x.Id))
      })
    },
    rewardSettingFilter: function () {
      return this.rewardSettingDataList
    },
    sampleSize: function () {
      return _.reduce(this.form.rewards, function (prev, next) {
        return parseInt(prev) + parseInt(next.occurrence)
      }, 0)
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getPercent (val) {
      return parseFloat(val / this.sampleSize)
    },
    selectReward (item, action) {
      if (!this.checkAccessPrivilege('ScratchCard.Settings.Rewards.Update')) {
        return
      }
      if (action === 1) {
        this.rewardSettingDataList.push(item)
      } else if (action === 0) {
        this.rewardSettingDataList = _.filter(this.rewardSettingDataList, function (x) { return item.Id !== x.Id })
      }
    },
    setData () {
      this.rewardListData = this.rewardList
      this.rewardSettingDataList = this.rewardSettingData
    },
    goBack () {
      this.form.rewards = []
      this.setOccurrence = false
    },
    next () {
      if (this.rewardSettingDataList.length === 0) {
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Must Select Reward to set occurrence.')
        return
      }
      this.form.rewards = []
      this.setOccurrence = true
      let $this = this
      _.each(this.rewardSettingDataList, function (x) {
        let occ = (x.hasOwnProperty('Occurrence')) ? x.Occurrence : 0
        $this.form.rewards.push({ rewardId: x.Id, occurrence: occ })
      })
    },
    async save () {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/scratchcard/reward/saveRewardMap', {
          cardId: this.cardId,
          rewardData: this.form.rewards
        }, { headers: { 'Content-Type': 'application/json' } })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Rewards updated successfully')
        this.cancelModal()
      } catch (err) {
        console.log(err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    cancelModal () {
      this.form.filter = 0
      this.setOccurrence = false
      this.rewardListData = []
      this.rewardSettingDataList = []
      this.$emit('closeModal')
    },
    moveAll (action) {
      if (action === 1) {
        this.rewardSettingDataList = [ ...this.rewardSettingDataList, ...this.rewardListFilter ]
        this.rewardListData = []
      } else if (action === 0) {
        this.rewardListData = [ ...this.rewardSettingDataList, ...this.rewardListFilter ]
        this.rewardSettingDataList = []
      }
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  }
}
</script>

<style scoped>
.list-wrapper {
  border: 1px solid #cccccc;
  padding: 10px;
  border-radius: 5px;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.list-wrapper .reward-wrapper {
  margin: 5px;
  cursor: pointer;
  margin-bottom: 10px;
}

.reward-setting-data-list-wrapper {
  margin-top: 15px;
  max-height: 550px;
  overflow-x: hidden;
  overflow-y: auto;
}

.reward-info {
  height: 50px
}
</style>


// WEBPACK FOOTER //
// src/views/scratchcard/settings/RewardSetting.vue